export const EstadoVistaColaborador = Object.freeze({
  PENDIENTE: "PENDIENTE",
  VISUALIZADO: "VISUALIZADO",
  FIRMADO: "FIRMADO",
  SUBIDO: "SUBIDO",
  OMITIDO: "OMITIDO",
});
